import { Handle, Position, NodeProps } from '@xyflow/react';

interface WaitForReplyNodeData {
  config: string;
  [key: string]: unknown;
}

const COLOR = '#64748b';

/**
 * Nó "Aguardar resposta do cliente". Pausa o fluxo esperando uma mensagem do contato.
 * Duas saídas:
 *  - "continue" (porta inferior): o contato respondeu dentro do prazo.
 *  - "timeout"  (porta direita): o contato não respondeu no tempo configurado.
 * Os ids das portas viram {"value":"<id>"} na condition da aresta — o engine usa isso
 * pra rotear (FlowExecutionService.FindNextNode / FindEdgeByHandle).
 */
export function WaitForReplyNode({ data, selected }: NodeProps) {
  const d = data as WaitForReplyNodeData;
  const minutes = parseTimeout(d.config);

  return (
    <div
      className="wt-rf-node wt-rf-node-waitreply"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: COLOR, minWidth: 200 }}
    >
      <Handle type="target" position={Position.Top} className="wt-rf-port" />
      <div className="wt-rf-node-head" style={{ color: COLOR }}>
        <span className="wt-rf-node-dot" style={{ background: COLOR }} />
        <span>Aguardar resposta</span>
      </div>
      <div className="wt-rf-node-preview">
        {minutes > 0 ? `Sem resposta em ${minutes} min` : 'Sem timeout'}
      </div>

      <div className="wt-rf-waitreply-out wt-rf-waitreply-timeout">
        <span>sem resposta</span>
        <Handle
          type="source"
          position={Position.Right}
          id="timeout"
          className="wt-rf-port wt-rf-port-timeout"
        />
      </div>

      <div className="wt-rf-waitreply-out wt-rf-waitreply-continue">
        <span>respondeu</span>
        <Handle
          type="source"
          position={Position.Bottom}
          id="continue"
          className="wt-rf-port wt-rf-port-continue"
        />
      </div>
    </div>
  );
}

function parseTimeout(configJson: string): number {
  try {
    const cfg = JSON.parse(configJson || '{}');
    const m = cfg.timeoutMinutes;
    return typeof m === 'number' && m > 0 ? m : 0;
  } catch {
    return 0;
  }
}
